/* eslint-disable */
import React, { useState, useMemo } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import Box from '@mui/material/Box';
import { TableSortLabel } from '@mui/material';
import _ from 'lodash';
import { visuallyHidden } from '@mui/utils';
import { useNavigate } from 'react-router-dom';
import addCommas from '../utils/functions/commas';
import dayjs from 'dayjs';
import api from '../utils/functions/api';
import { getStorage } from '../utils/functions/localstorage';
import Swal from 'sweetalert2';

import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

const columns = [
  { id: 'date_created', label: 'วันที่สร้างรายการ', align: 'center' },
  { id: 'date_pay', label: 'วันที่ทำรายการ', align: 'center' },
  { id: 'company_name', label: 'ชื่อร้านค้า', align: 'center' },
  { id: 'order_id', label: 'เลขอ้างอิงรายการของร้านค้า', align: 'center' },
  { id: 'ref', label: 'เลขอ้างอิงรายการชำระ', align: 'center' },
  { id: 'amount', label: 'ยอดเงินชำระ', align: 'center' },
  { id: 'payment_status', label: 'สถานะ', align: 'center' },
  { id: 'pay_type', label: 'ช่องทางการชำระเงิน', align: 'center' },
  { id: 'actions', label: '', align: 'center' }, // เพิ่มคอลัมน์ลบ
];

function TableHistorySuperAdmin({
  ishistorySuperAdmin,
  handleRequestSort,
  orderDirection,
  valueToOrderBy,
  pagination,
  handlePaginationChange,
}) {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const createSortHead = (property) => (event) => {
    handleRequestSort(event, property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handlePaginationChange('handleChangePage', newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    handlePaginationChange('handleChangeRowsPerPage', event.target.value);
  };

  const handleDelete = async (index) => {
    // แสดงกล่องยืนยันการลบ
    const confirm = await Swal.fire({
      title: 'คุณแน่ใจหรือไม่?',
      text: 'คุณต้องการลบรายการนี้ใช่หรือไม่',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'ใช่, ลบเลย!',
      cancelButtonText: 'ยกเลิก',
    });

    // ถ้าผู้ใช้ยืนยัน
    if (confirm.isConfirmed) {
      const token = getStorage('token');
      try {
        await api.delete(
          `${process.env.REACT_APP_APIHOST}/canceltransaction/${index}`,
          {
            headers: { Authorization: token },
          },
        );

        // แสดงข้อความสำเร็จ
        await Swal.fire({
          title: 'สำเร็จ!',
          text: 'ลบรายการเรียบร้อยแล้ว',
          icon: 'success',
          confirmButtonText: 'ตกลง',
        });

        // รีโหลดหน้าปัจจุบัน (สามารถเปลี่ยนเป็น fetch ใหม่แทนได้)
        window.location.reload();
      } catch (error) {
        console.error('ลบไม่สำเร็จ', error);
        // แสดงข้อความ error
        Swal.fire({
          title: 'เกิดข้อผิดพลาด',
          text: 'ไม่สามารถลบรายการได้',
          icon: 'error',
          confirmButtonText: 'ตกลง',
        });
      }
    }
  };

  return (
    <>
      <TableContainer sx={{ maxHeight: 460, overflowY: 'auto' }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth, color: '#fff' }}
                >
                  <TableSortLabel
                    active={valueToOrderBy === column.id}
                    direction={
                      valueToOrderBy === column.id
                        ? _.toLower(orderDirection)
                        : _.toLower('asc')
                    }
                    onClick={createSortHead(column.id)}
                  >
                    {column.label}
                    {valueToOrderBy === column.id ? (
                      <Box component="span" sx={visuallyHidden}>
                        {orderDirection === 'desc'
                          ? 'sorted descending'
                          : 'sorted ascending'}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {_.size(ishistorySuperAdmin) ? (
            <TableBody>
              {ishistorySuperAdmin
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <TableRow
                    key={index}
                    // sx={{
                    //   '&:last-child td, &:last-child th': { border: 0 },
                    // }}
                    // className="hover:bg-gray-200 cursor-pointer"
                  >
                    <TableCell align="center">
                      {row.date_created
                        ? dayjs(row.date_created).format('DD-MM-YYYY')
                        : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.date_pay
                        ? dayjs(row.date_pay).format('DD-MM-YYYY')
                        : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.company_name ? row.company_name : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.order_id ? row.order_id : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.ref ? row.ref : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.amount ? addCommas(row.amount) : '-'}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        color:
                          row.payment_status === 'Success'
                            ? 'green'
                            : row.payment_status === 'Fail'
                            ? 'red'
                            : row.payment_status === 'Pending'
                            ? '#FFA500' // สีเหลืองออกส้ม (orange)
                            : 'gray',
                      }}
                    >
                      {row.payment_status ? row.payment_status : '-'}
                    </TableCell>
                    <TableCell align="center">
                      {row.pay_type ? row.pay_type : '-'}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        onClick={() => handleDelete(row.id)} // ตรวจสอบว่า row.id มีค่าถูกต้อง
                        aria-label="delete"
                      >
                        <DeleteIcon sx={{ color: 'red' }} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <div>ไม่มีข้อมูล</div>
                </TableCell>
              </TableRow>
            </TableBody>
          )}
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={pagination.total}
        rowsPerPage={pagination.size}
        page={pagination.currPage - 1}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
}

export default TableHistorySuperAdmin;
